module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_photowedding@3x-38679583d5a65cb068d2515982774cef.webp";